import { render, staticRenderFns } from "./ConcordHospitalityGroup.vue?vue&type=template&id=5a4192d6&scoped=true"
import script from "./ConcordHospitalityGroup.vue?vue&type=script&lang=js"
export * from "./ConcordHospitalityGroup.vue?vue&type=script&lang=js"
import style0 from "./ConcordHospitalityGroup.vue?vue&type=style&index=0&id=5a4192d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4192d6",
  null
  
)

export default component.exports